var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"name module"},[_c('h2',{staticClass:"display"},[_vm._v(_vm._s(_vm.service.name))]),_c('span',[_vm._v(_vm._s(_vm.service.alternative_name))]),_c('div',{staticClass:"more"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }